import { useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";

import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const style =
  "px-4 pt-4 pb-2 bg-white text-3xl h-16 font-semibold w-full text-right";

function CharInlineField({
  name,
  readOnly,
  data,
  placeholder,
  onChange,
  translate,
  uppercase,
  msg,
  label,
  layout,
  icon,
  specialCharacters,
  type,
  autoFocus = false,
}) {
  let _value = data.value || "";

  // const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (autoFocus) {
      focusInput();
    }
  }, [autoFocus]);

  if (_value && layout && translate) {
    const _valueRef = `${layout.model}.${_value}`;
    _value = intl.msgs[_valueRef] || _value;
  }

  let _color;
  if (readOnly) {
    _color = colors.readOnly;
  }

  function handleChange(event) {
    let newValue = event.target.value;

    if (uppercase) {
      newValue = newValue.toUpperCase();
    }
    if (specialCharacters && type === "char") {
      newValue = newValue.replace(/[^\w\s]|[\dñ]/gi, "");
      newValue = newValue.replace("  ", " ").toUpperCase();
    }
    data.value = newValue;
  }

  function handleEvent(e) {
    if (e.key === "Delete") {
      onChange({ target: { value: "" } });
    }
  }

  function onBlur() {
    if (onChange) {
      onChange(name, _value);
    }
  }

  function focusInput() {
    // setFocused(true);
    const inputElement = document.getElementById(name);
    if (inputElement) {
      inputElement.focus();
      const length = inputElement.value.length;
      inputElement.setSelectionRange(length, length);
    }
  }

  return (
    <div className="flex items-center justify-center space-x-5 w-full mt-4 mb-1 min-h-12 max-w-2xl mx-auto">
      <div className="text-2xl font-bold text-zinc-500 w-3/6 text-right">
        <FM id={label} key={name} />
      </div>
      <div className="w-full overflow-x-hidden">
        <div className="relative">
          <input
            key={name}
            id={name}
            name={name}
            type="text"
            value={data.value}
            onChange={handleChange}
            onBlur={onBlur}
            onKeyDown={handleEvent}
            disabled={readOnly ?? false}
            placeholder={placeholder ?? ""}
            title={msg ?? ""}
            className={cn(_color, style, theme.textColor, theme.border)}
          />
        </div>
      </div>
      <span>{icon || null}</span>
    </div>
  );
}

export default CharInlineField;
